import { FC } from 'react';

import clsx from 'clsx';

import { EmptyAiresStateProps } from './types';

import styles from './styles.module.scss';

import ChartIcon from '@/assets/icons/chart.svg?react';

export const EmptyAiresState: FC<EmptyAiresStateProps> = ({ children, showChartIcon, title, text, styleClass }) => (
  <div className={clsx(styles.emptyState, styleClass)}>
    <div>
      {showChartIcon && (
        <div className={styles.emptyState__img}>
          <ChartIcon />
        </div>
      )}

      <h2 className={styles.emptyState__title}>{title}</h2>
      <p className={styles.emptyState__text}>{text}</p>
      <div className={styles.emptyState__btn}>{children}</div>
    </div>
  </div>
);
